/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage } from '@hookform/error-message';
import classNames from 'classnames';
import _ from 'lodash';
import { Button } from 'primereact/button';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import {
  ContainerField,
  ContainerFormField,
  ContainerInput,
  ContainerSubLabel,
  Error,
  HelpTextComponent,
  Label,
} from './components';
import ModalImg from './ModalImg';

const SimpleContainer = ({
  children,
  name,
  label,
  subLabel = null,
  helpText,
  info = null,
  labelClass = 'labelDropDown',
  infoImg = null,
  labelProps = {},
  hide = false,
  classContainer = '',
  infoIcon = 'pi pi-question',
}) => {
  const { errors } = useFormContext();
  return (
    <ContainerFormField
      className={classNames({
        'd-none': hide,
      })}
    >
      <Label htmlFor={name} style={{ fontSize: '20px' }} {...labelProps}>
        {label}{' '}
        {info !== null && (
          <Button
            type="button"
            label=""
            icon={infoIcon}
            tooltip={info}
            className="btn-info-label"
            tooltipOptions={{ position: 'top' }}
          />
        )}
        {infoImg !== null && <ModalImg img={infoImg} useModal={'si'} />}
      </Label>

      <ContainerInput
        className={'d-flex-column ' + classContainer}
        hasError={!!_.get(errors, name)}
      >
        <div className="d-inline-flex w-100" style={{}}>
          <ContainerField className="w-100">{children}</ContainerField>
          {subLabel && <ContainerSubLabel subLabel={subLabel} />}
        </div>
        {helpText && (
          <div className="d-flex flex-row justify-content-center" style={{ margin: '0 0 0 0' }}>
            <HelpTextComponent width="95%">{helpText}</HelpTextComponent>
          </div>
        )}
        <div
          className="d-flex flex-row justify-content-center"
          style={{ marginTop: '0', marginBottom: '0' }}
        >
          <ErrorMessage
            name={name}
            errors={errors}
            render={({ message }) => <Error width="95%">{message}</Error>}
          />
        </div>
      </ContainerInput>
    </ContainerFormField>
  );
};

export default SimpleContainer;
